import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { LazyLoadEvent } from "primeng/api";
import { Table } from "primeng/table";
import { ArquivoImportacaoFinalizado } from "src/app/base/domain/arquivo-importacao-finalizado.model";
import { ArquivoImportacaoNovo } from "src/app/base/domain/arquivo-importacao-novo.model";
import { Posto } from "src/app/base/domain/posto.model";
import { ArquivoImportacaoNovoService } from "src/app/base/services/arquivo-importacao-novo.service";
import { CardListComponent } from "../../components/card-list/card-list.component";
import { DialogService } from "../../services/dialog.service";

export interface ArquivoImportacaoAcaoEvent {
    acao: string;
    arquivo: ArquivoImportacaoNovo;
}

export interface ArquivoImportacaoNovoListFilterOptions {
    postoSelecionado: Posto;
    dataInicial: Date;
    dataFinal: Date;
}

@Component({
    selector: 'app-arquivo-importacao-novo-list',
    templateUrl: './arquivo-importacao-novo-list.component.html',
    styleUrls: ['./arquivo-importacao-novo-list.component.css'],
})
export class ArquivoImportacaoNovoListComponent implements OnInit {

    @ViewChild('searchForm', { static: false }) searchForm: NgForm;
    @ViewChild('dataTable', { static: false }) dataTable: Table;
    @ViewChild(CardListComponent, { static: true }) cardList: CardListComponent;

    @Input() arquivos: ArquivoImportacaoNovo[];
    @Input() totalRecords: number;
    @Input() rowsNumber: number;
    @Input() loading: boolean;
    @Input() title: string;
    @Input() nomePlaceholder: string;
    @Input() dataPlaceholder: string;
    @Input() filtros: string[];
    @Input() options: string[];
    @Input() optionalColumns: string[];
    @Input() menuAcoes: string[];

    @Output() loadArquivosPage = new EventEmitter<number>();
    @Output() disclosureArquivo = new EventEmitter<ArquivoImportacaoNovo>();
    @Output() filter = new EventEmitter<ArquivoImportacaoNovoListFilterOptions>();
    @Output() acaoClick = new EventEmitter<ArquivoImportacaoAcaoEvent>();

    @Output() imprimirLote = new EventEmitter<ArquivoImportacaoNovo[]>();

    private currentPage = 0;

    private readonly defaultFilterOptions: ArquivoImportacaoNovoListFilterOptions = {
        postoSelecionado: null,
        dataInicial: null,
        dataFinal: null
    };

    filterOptions: ArquivoImportacaoNovoListFilterOptions;

    constructor(private arquivoImportacaoNovoService: ArquivoImportacaoNovoService,
        public dialog: MatDialog,
        public dialogService: DialogService) { }

    ngOnInit(): void {
        this.onLimparFiltros();
    }

    loadArquivos(event: LazyLoadEvent): void {
        const pageNumber = Math.floor(event.first / event.rows);
        this.currentPage = pageNumber;
        this.loadArquivosPage.emit(pageNumber);
    }

    onDisclosure(arquivo: ArquivoImportacaoNovo): void {
        this.disclosureArquivo.emit(arquivo);
    }

    onAtualizar(): void {
        this.loadArquivosPage.emit(this.currentPage);
    }

    onLimparFiltros(): void {
        if (this.filterOptions) {
            this.filterOptions.dataInicial = null;
            this.filterOptions.dataFinal = null;
        }
        this.filterOptions = Object.assign({}, this.defaultFilterOptions);
    }

    onAplicarFiltro(): void {
        this.filter.emit(this.filterOptions);
    }

    generateMask(value: number): string {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    onAcaoClick(acao: string, domain: ArquivoImportacaoNovo): void {
        this.acaoClick.emit({ acao, arquivo: domain });
    }
}